import React from 'react';
import Slider from 'rc-slider';
import Moment from 'react-moment';

export default function IntervaloDataFilter(props) {

    const { createSliderWithTooltip } = Slider;
    const Range = createSliderWithTooltip(Slider.Range);

    return (
        <Range
            defaultValue={props.intervaloDataValue.length > 0 ? props.intervaloDataValue : [props.intervaloData.min, props.intervaloData.max]}
            min={props.intervaloData.min}
            max={props.intervaloData.max}
            step={props.intervaloData.step}
            marks={props.intervaloData.marks}
            dots
            allowCross={false}
            tipFormatter={value => (
                <Moment format={props.intervaloData.format}>
                    {value}
                </Moment>
            )}
            onAfterChange = {(value) => {
                props.onChangeValue({
                    intervaloDataValue: (
                        value[0] > props.intervaloData.min ||
                        value[1] < props.intervaloData.max
                    )
                        ? value
                        : []
                });
            }}
        />
    );
}
